import React from "react";
// import "./LeftPanel.css";

export default function LeftPanel({ activeStep }) {
  return (
    
    <div className="left-panel">

      {/* HEADING */}
      <h1 className="left-title">
        Apply to<br />
        become a<br />
        Docusafe Partner
      </h1>

      {/* UNDERLINE */}
      <div className="left-underline"></div>

      {/* STEP LIST */}
      <div className="step-flow">

        {/* STEP 1 */}
        <div className={`partner-step-item ${activeStep === 1 ? "active" : ""}`}>
          <div className="step-icon">
            {activeStep > 1 ? "✔" : "1"}
          </div>
          <span>Contact and Business Details</span>
        </div>

        {/* LINE */}
        <div className={`step-line ${activeStep > 1 ? "filled" : ""}`}></div>

        {/* STEP 2 */}
        <div className={`partner-step-item ${activeStep === 2 ? "active" : ""}`}>
          <div className="step-icon">
            {activeStep > 2 ? "✔" : "2"}
          </div>
          <span>Area of Expertise</span>
        </div>

        <div className={`step-line ${activeStep > 2 ? "filled" : ""}`}></div>

        {/* STEP 3 */}
        <div className={`partner-step-item ${activeStep === 3 ? "active" : ""}`}> 
          <div className="step-icon">3</div>
          <span>Choose a Partner Program</span>
        </div>

      </div>
    </div>
  );
}
